import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect, useRef } from 'react';
import { useIntersection, useWindowScroll } from 'react-use';
import PropTypes from 'prop-types';
import isServer from 'commons/isServer';
import getWindowHeight from 'commons/getWindowHeight';
import isBotRequest from 'commons/isBotRequest';
import isSkipFoldRequest from 'commons/isSkipFoldRequest';
const shouldRenderForNonBot = (componentIndex, disableOnServer) => {
  if (disableOnServer && isServer()) {
    return false;
  }
  return componentIndex < 5;
};
const AboveTheFoldServerRendererLegacy = t0 => {
  const $ = _c(16);
  const {
    children,
    componentIndex: t1,
    disableOnServer,
    renderImmediatelyOnClient
  } = t0;
  const componentIndex = t1 === undefined ? 5 : t1;
  let t2;
  if ($[0] !== componentIndex || $[1] !== disableOnServer) {
    t2 = () => isBotRequest() || isSkipFoldRequest() ? true : shouldRenderForNonBot(componentIndex, disableOnServer);
    $[0] = componentIndex;
    $[1] = disableOnServer;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [shouldRender, setShouldRender] = useState(t2);
  const intersectionRef = useRef(null);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      root: null,
      rootMargin: `${getWindowHeight() * 0.75 || 0}px`,
      threshold: 0
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const intersection = useIntersection(intersectionRef, t3);
  const {
    y: scrollY
  } = useWindowScroll();
  let t4;
  if ($[4] !== intersection || $[5] !== shouldRender) {
    t4 = () => {
      if (shouldRender || !intersection || !intersection.isIntersecting) {
        return;
      }
      setShouldRender(true);
    };
    $[4] = intersection;
    $[5] = shouldRender;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== intersection || $[8] !== scrollY || $[9] !== shouldRender) {
    t5 = [intersection, scrollY, shouldRender];
    $[7] = intersection;
    $[8] = scrollY;
    $[9] = shouldRender;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[11] !== renderImmediatelyOnClient || $[12] !== shouldRender) {
    t6 = () => {
      if (renderImmediatelyOnClient && !shouldRender) {
        setShouldRender(true);
      }
    };
    t7 = [renderImmediatelyOnClient, shouldRender];
    $[11] = renderImmediatelyOnClient;
    $[12] = shouldRender;
    $[13] = t6;
    $[14] = t7;
  } else {
    t6 = $[13];
    t7 = $[14];
  }
  useEffect(t6, t7);
  if (shouldRender) {
    return children;
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div ref={intersectionRef} className="AboveTheFoldServerRenderer__filler" style={{
      minHeight: "500px"
    }} />;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
AboveTheFoldServerRendererLegacy.propTypes = {
  children: PropTypes.node.isRequired,
  componentIndex: PropTypes.number,
  disableOnServer: PropTypes.bool,
  renderImmediatelyOnClient: PropTypes.bool
};
export default AboveTheFoldServerRendererLegacy;